import { CommerceApiContext, CommerceApiProductContext } from '../../common/types';
import { ProductExperienceApi } from '../../models/product/product.api';
import { BffOcbProductExperienceApi } from './bff-to-product';
import { FocProductExperienceApi } from './foc-to-product';
import { OcbProductExperienceApi } from './ocb-to-product';

export const productExperienceAdapterFactory = (options: CommerceApiProductContext): ProductExperienceApi => {
  switch (options.context) {
    case CommerceApiContext.FOC:
      return new FocProductExperienceApi(options.httpServices.product.foc);
    case CommerceApiContext.OCB:
      return options.isBffEnabled
        ? new BffOcbProductExperienceApi(options.httpServices.product.bff, options.i18n, options.mapVehicleModel)
        : new OcbProductExperienceApi(options.httpServices.product.ocb, options.i18n, options.mapVehicleModel);
    default:
      throw new Error(`Unknown CommerceApiContext ${options.context}`);
  }
};
